import { Component, OnInit } from '@angular/core';
import { HelenaApiService } from '../../../services/helena-api.service';
import { ActivatedRoute } from '@angular/router';
import { TankmixTest } from '../../../models/searchRequest';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { PreferencesService } from 'src/app/services/preferences.service';
import { tap } from 'rxjs';
@Component({
  selector: 'app-helena-tankmix-detail',
  templateUrl: './helena-tankmix-detail.component.html'
})
export class HelenaTankmixDetailComponent implements OnInit {
  faPrint = faPrint;
  testResult: TankmixTest;
  unitsChoice: string;
  constructor(private helenaApi: HelenaApiService, private route: ActivatedRoute,  private preferencesService: PreferencesService) { }

  ngOnInit() {
    this.helenaApi.getOutcome(this.route.snapshot.params.tankmixId).subscribe(x => this.testResult = x);
    this.preferencesService.unitsChoice$
    .pipe(
      tap((unitsChoice) => {
        this. unitsChoice = unitsChoice;
      })
    )
    .subscribe();
  }
  convertedAppRate(inp: number) {
    return this.preferencesService.convertApplicationUnits(inp);
  }
  convertedWaterRate(inp: number) {
    return this.preferencesService.convertWaterUnits(inp);
  }
  convertPowderUnits(inp:number) {
    return this.preferencesService.convertPowderUnits(inp);
  }
}
